import { FC } from 'react';

interface Props {
  color?: string;
  className?: string;
  isActive?: boolean;
}

const ToggleArrowSvg: FC<Props> = ({ isActive = false, className, color }) => {
  if (isActive)
    return (
      <svg
        className={className}
        width='12'
        height='7'
        viewBox='0 0 12 7'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M5.5584 5.94173C5.67558 6.05877 5.83444 6.12451 6.00006 6.12451C6.16569 6.12451 6.32454 6.05877 6.44173 5.94173L11.4417 0.941728C11.5588 0.824541 11.6245 0.665688 11.6245 0.500062C11.6245 0.334436 11.5588 0.175583 11.4417 0.0583954L0.558395 0.0583944C0.441353 0.175582 0.375613 0.334435 0.375613 0.500061C0.375613 0.665687 0.441353 0.82454 0.558395 0.941727L5.5584 5.94173Z'
          fill={color ?? 'currentColor'}
        />
      </svg>
    );

  return (
    <svg
      className={className}
      width='12'
      height='7'
      viewBox='0 0 12 7'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.4416 1.05827C6.32442 0.94123 6.16556 0.875488 5.99994 0.875488C5.83431 0.875488 5.67546 0.94123 5.55827 1.05827L0.558271 6.05827C0.441229 6.17546 0.375488 6.33431 0.375488 6.49994C0.375488 6.66556 0.441229 6.82442 0.558271 6.9416L11.4416 6.9416C11.5586 6.82442 11.6244 6.66556 11.6244 6.49994C11.6244 6.33431 11.5586 6.17546 11.4416 6.05827L6.4416 1.05827Z'
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
};

export default ToggleArrowSvg;
